import { Fragment } from "react";
import PropTypes from "prop-types";
import { PropertyName } from "../../../../components/PropertyName/PropertyName";

export const PropertyRow = ({ name }) => {
  if (name === "Residual")
    return <span className="font-style-italic">Residual</span>;

  if (!name.includes(":"))
    return <PropertyName showIcon technicalName={name} />;

  const splitted = name.split(":");

  return splitted.map((subKey, index) => (
    <Fragment key={index}>
      <PropertyName showIcon technicalName={subKey} />
      {index < splitted.length - 1 && (
        <i className="fa-solid fa-link discrete-icon ms-1 me-1" />
      )}
    </Fragment>
  ));
};

PropertyRow.propTypes = {
  name: PropTypes.string.isRequired,
};
